export enum ModerationStatus {
  /** Модератор не назначен */
  Free = 1,
  /** Есть модератор, нет решения */
  InWork = 2,
  Success = 3,
  NotPass = 4,
}
